import React, {useRef, useState} from 'react';
import {Box, Button, Divider, InputAdornment, TextField, Typography, useMediaQuery} from "@mui/material";
// import {useForm} from "react-hook-form";

const Table = () => {
    // const {register, watch, handleSubmit, control} = useForm();

    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const [earning, setEarnings] = useState(null);
    const [earningFromClientMark, setEarningFromClientMark] = useState(null);
    const [howManyPeopleToseeUs, setHowManyPeopleToseeUs] = useState(null);

    const [cv2, setCv2] = useState(null);
    const [payments, setPayments] = useState(null);
    const [averageBill, setAverageBill] = useState(null);
    const [earnFromClients, setEarnFromClients] = useState(null);
    const [cv3, setCv3] = useState(null);
    const [clearClientsCounter, setClearClientsCounter] = useState(null);
    const [earningFromClient, setEarningFromClient] = useState(null);

    const [clientCounter, setClientCounter] = useState(null);
    const [vyruchka, setVyruchka] = useState(null);
    const [prodaj, setProdaj] = useState(null);
    const [vyruchkaOtKlientovSMarketinga, setVyruchkaOtKlientovSMarketinga] = useState(null);

    const earningsFromClientsRef = useRef(null)

    const count = useRef(null)

    // CV1 (Показы / Заявки), %
    const getPeopleCounter = (e) => {
        setEarningFromClientMark(e.target.value)
        // setHowManyPeopleToseeUs((e.target.value * earning) / 100)

    }

    // Сколько человек нас увидело
    const earningsOnChange = (e) => {
        setEarnings(e.target.value)
        // setHowManyPeopleToseeUs((e.target.value * earningFromClientMark) / 100)
    }

    //CV2 (конверсия в оплату)
    const setCv2OnChange = (e) => {
        setCv2(e.target.value)
    }


    // Средний чек
    const averageBillOnChange = (e) => {
        setAverageBill(e.target.value)
        // setEarningFromClient(e.target.value * clearClientsCounter)
        // setEarnFromClients(e.target.value * payments)
        // earningsFromClientsRef.current = e.target.value * (cv3 * (cv2 * howManyPeopleToseeUs) / 100)
        // count.current = (e.target.value * payments) + earningFromClient

        // countClients()
    }

    // CV3 (конверсия в постоянных клиентов)
    const cv3OnChange = (e) => {
        setCv3(e.target.value)
        // setClearClientsCounter(Math.ceil((e.target.value * payments) / 100))
        // setEarningFromClient(Math.ceil((e.target.value * payments) / 100) * averageBill)
    }

    const buttonOnClick = () => {

        let postojannyeKlienty = Math.ceil(cv3 / 100 * ((earningFromClientMark * earning) / 100) * cv2 / 100)
        let prodajLocal = Math.ceil(((earningFromClientMark * earning) / 100) * cv2 / 100)

        // Заявки
        setHowManyPeopleToseeUs((earningFromClientMark * earning) / 100)

        // Продаж
        setProdaj(prodajLocal)

        // Выручка от клиентов с маркетинга
        setVyruchkaOtKlientovSMarketinga(averageBill * prodajLocal)

        // Постоянные клиенты
        setClientCounter(postojannyeKlienty)

        // Выручка от постоянных клиентов
        earningsFromClientsRef.current = postojannyeKlienty * averageBill

        // Выручка
        setVyruchka((postojannyeKlienty * averageBill) + (averageBill * prodajLocal))
    }

    return (
        <Box sx={{
            maxWidth: 700,
            m: 'auto',
        }}>
            <Box
                sx={{
                    "& .MuiTextField-root": {
                        maxWidth: matches ? 200 : 100
                    }
                }}>

                <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 3}}>
                    <Typography variant='h5'>Выручка</Typography>
                    <Typography variant='h5'>
                        {/*{(earnFromClients + earningFromClient).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}, ₽*/}
                        {vyruchka?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}, ₽
                    </Typography>
                </Box>
                <Divider/>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2}}>
                    <Typography variant={matches ? 'h4' : 'h5'}><strong>Показы</strong></Typography>
                    <TextField
                        sx={{width: matches ? 200 : 120}}
                        type='number'
                        size='small'
                        placeholder='0'
                        onChange={earningsOnChange}
                        defaultValue={earning !== null && earning}/>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 0.3}}>
                    <Typography>CV1 (Показы / Заявки), %</Typography>
                    <TextField
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    %
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            width: matches ? 200 : 120,
                        }}
                        type='number'
                        size='small'
                        placeholder='0'
                        onChange={getPeopleCounter}
                        value={earningFromClientMark !== null && earningFromClientMark}/>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1}}>
                    <Typography
                        variant={matches ? 'h4' : 'h5'}><strong>Заявки</strong></Typography>
                    <Box sx={{
                        width: matches ? 200 : 120,
                    }}>

                        <Typography sx={{
                            ml: matches ? 0 : 3,
                            textAlign: 'left',
                            display: 'flex',
                            fontSize: matches ? 25 : 15,
                        }}><strong>{howManyPeopleToseeUs === null ? '-' : howManyPeopleToseeUs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
                    </Box>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography>CV2 (конверсия в оплату), %</Typography>
                    <TextField
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    %
                                </InputAdornment>
                            ),
                        }}
                        type='number'
                        size='small'
                        placeholder='0'
                        onChange={setCv2OnChange}
                        value={cv2 !== null && cv2}/>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1}}>
                    <Typography
                        variant={matches ? 'h4' : 'h5'}><strong>Продаж</strong></Typography>
                    <Box sx={{
                        width: matches ? 200 : 120,
                    }}>
                        <Typography sx={{
                            display: 'flex',
                            ml: matches ? 0 : 3,
                            textAlign: 'left',
                            fontSize: matches ? 25 : 15
                        }}><strong>{prodaj === null ? '-' : prodaj}</strong></Typography>
                    </Box>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 0.3}}>
                    <Typography sx={{
                        fontSize: matches ? 25 : 15
                    }}><strong>Средний чек</strong></Typography>
                    <TextField
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">₽</InputAdornment>
                            ),
                        }}
                        type='number'
                        size='small'
                        placeholder='0'
                        onChange={averageBillOnChange}
                        value={averageBill !== null && averageBill}/>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 2}}>
                    <div>

                        <Typography
                            sx={{
                                fontSize: matches ? 25 : 15
                            }}
                        ><strong>Выручка</strong></Typography>

                        <Typography
                            sx={{
                                fontSize: 16
                            }}
                        >от клиентов с маркетинга</Typography>

                    </div>
                    <Box sx={{width: matches ? 200 : 120}}>
                        <Typography sx={{
                            display: 'flex',
                            ml: matches ? 0 : 3,
                            fontSize: matches ? 25 : 15
                        }}><strong>{vyruchkaOtKlientovSMarketinga === null ? '-' : vyruchkaOtKlientovSMarketinga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ', ₽'}</strong></Typography>
                    </Box>
                </Box>

                <Divider sx={{my: 2}}/>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography>CV3 (конверсия в постоянных клиентов), %</Typography>
                    <TextField
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">%</InputAdornment>
                            ),
                        }}
                        type='number'
                        size='small'
                        placeholder='0'
                        value={cv3 !== null && cv3}
                        onChange={cv3OnChange}/>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 2}}>
                    <Typography
                        sx={{
                            fontSize: matches ? 25 : 15
                        }}
                    ><strong>Постоянные клиенты</strong>
                    </Typography>
                    <Box sx={{width: matches ? 200 : 120}}>
                        <Typography sx={{
                            display: 'flex',
                            ml: matches ? 0 : 3,
                            textAlign: 'left',
                            fontSize: matches ? 25 : 15
                        }}><strong>{clientCounter === null ? '-' : clientCounter}</strong></Typography>
                    </Box>
                </Box>

                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div>

                        <Typography><strong>Выручка</strong></Typography>
                        <Typography>от постоянных клиентов</Typography>
                    </div>
                    <Box sx={{width: matches ? 200 : 120}}>
                        <Typography sx={{
                            display: 'flex',
                            ml: matches ? 0 : 3,
                            textAlign: 'left',
                            fontSize: matches ? 25 : 15
                        }}><strong>{earningsFromClientsRef.current === null ? '-' : earningsFromClientsRef.current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ', ₽'}</strong></Typography>
                    </Box>
                </Box>
            </Box>
            <Button
                sx={{
                    display: 'flex',
                    mx: 'auto',
                    mt: 5,
                    height: 60,
                    width: '80%',
                }}
                variant='contained' onClick={buttonOnClick}>Посчитать</Button>
        </Box>
    );
};

export default Table;


// Old Version
//
//
// import React, {useRef, useState} from 'react';
// import {Box, Button, Divider, TextField, Typography, useMediaQuery} from "@mui/material";
// // import {useForm} from "react-hook-form";
//
// const Table = () => {
//     // const {register, watch, handleSubmit, control} = useForm();
//
//     const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));
//
//     const [earning, setEarnings] = useState(null);
//     const [earningFromClientMark, setEarningFromClientMark] = useState(null);
//     const [howManyPeopleToseeUs, setHowManyPeopleToseeUs] = useState(null);
//
//     const [cv2, setCv2] = useState(null);
//     const [payments, setPayments] = useState(null);
//     const [averageBill, setAverageBill] = useState(null);
//     const [earnFromClients, setEarnFromClients] = useState(null);
//     const [cv3, setCv3] = useState(null);
//     const [clearClientsCounter, setClearClientsCounter] = useState(null);
//     const [earningFromClient, setEarningFromClient] = useState(null);
//
//     const [clientCounter, setClientCounter] = useState(null);
//
//     const earningsFromClientsRef = useRef(null)
//
//     const count = useRef(null)
//
//     // CV1 (Показы / Заявки), %
//     const getPeopleCounter = (e) => {
//         setEarningFromClientMark(e.target.value)
//         setHowManyPeopleToseeUs((e.target.value * earning) / 100)
//     }
//
//     // Сколько человек нас увидело
//     const earningsOnChange = (e) => {
//         setEarnings(e.target.value)
//         setHowManyPeopleToseeUs((e.target.value * earningFromClientMark) / 100)
//     }
//
//     //CV2 (конверсия в оплату)
//     const setCv2OnChange = (e) => {
//         setCv2(e.target.value)
//         setCv2(e.target.value)
//     }
//
//
//     // Средний чек
//     const averageBillOnChange = (e) => {
//         setAverageBill(e.target.value)
//         setEarningFromClient(e.target.value * clearClientsCounter)
//         setEarnFromClients(e.target.value * payments)
//         earningsFromClientsRef.current = e.target.value * (cv3 * (cv2 * howManyPeopleToseeUs) / 100)
//
//         // count.current = (e.target.value * payments) + earningFromClient
//
//         // countClients()
//     }
//
//     // CV3 (конверсия в постоянных клиентов)
//     const cv3OnChange = (e) => {
//         setCv3(e.target.value)
//         setClearClientsCounter(Math.ceil((e.target.value * payments) / 100))
//         setEarningFromClient(Math.ceil((e.target.value * payments) / 100) * averageBill)
//     }
//
//     const buttonOnClick = () => {
//
//     }
//
//     return (
//         <Box sx={{
//             maxWidth: 700,
//             m: 'auto',
//         }}>
//             {/*<Typography sx={{mt: 4}} variant='h3'>Калькулятор</Typography>*/}
//             <Box
//                 sx={{
//                     "& .MuiTextField-root": {
//                         maxWidth: matches ? 200 : 100
//                     }
//                 }}>
//
//                 <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 3}}>
//                     <Typography variant='h5'>Выручка</Typography>
//                     <Typography variant='h5'>
//                         {/*{(earnFromClients + earningFromClient).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}, ₽*/}
//                         {(earningsFromClientsRef.current + (averageBill * (Math.ceil((cv2 * howManyPeopleToseeUs)/100)))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}, ₽
//                     </Typography>
//                 </Box>
//                 <Divider/>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 3}}>
//                     <Typography variant={matches ? 'h4' : 'h5'}><strong>Показы</strong></Typography>
//                     <TextField
//                         sx={{width: matches ? 200 : 120}}
//                         type='number'
//                         size='small'
//                         placeholder='0'
//                         onChange={earningsOnChange}
//                         defaultValue={earning !== null && earning}/>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 1}}>
//                     <Typography>CV1 (Показы / Заявки), %</Typography>
//                     <TextField
//                         sx={{
//                             width: matches ? 200 : 120,
//                         }}
//                         type='number'
//                         size='small'
//                         placeholder='0'
//                         onChange={getPeopleCounter}
//                         value={earningFromClientMark !== null && earningFromClientMark}/>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 3}}>
//                     <Typography
//                         variant={matches ? 'h4' : 'h5'}><strong>Заявки</strong></Typography>
//                     <Box sx={{
//                         width: matches ? 200 : 120,
//                     }}>
//
//                         <Typography sx={{
//                             ml: matches ? 0 : 3,
//                             textAlign: 'left',
//                             display: 'flex',
//                             fontSize: matches ? 25 : 15,
//                         }}><strong>{howManyPeopleToseeUs === null ? '-' : howManyPeopleToseeUs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                     </Box>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
//                     <Typography>CV2 (конверсия в оплату), %</Typography>
//                     <TextField
//                         type='number'
//                         size='small'
//                         placeholder='0'
//                         onChange={setCv2OnChange}
//                         value={cv2 !== null && cv2}/>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 3}}>
//                     <Typography
//                         variant={matches ? 'h4' : 'h5'}><strong>Продаж</strong></Typography>
//                     <Box sx={{
//                         width: matches ? 200 : 120,
//                     }}>
//                         <Typography sx={{
//                             display: 'flex',
//                             ml: matches ? 0 : 3,
//                             textAlign: 'left',
//                             fontSize: matches ? 25 : 15
//                             // }}><strong>{payments === null ? '-' : payments}</strong></Typography>
//                         }}><strong>{Math.ceil((cv2 * howManyPeopleToseeUs)/100)}</strong></Typography>
//                     </Box>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
//                     <Typography>CV3 (конверсия в постоянных клиентов), %</Typography>
//                     <TextField
//                         type='number'
//                         size='small'
//                         placeholder='0'
//                         value={cv3 !== null && cv3}
//                         onChange={cv3OnChange}/>
//                 </Box>
//
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 2}}>
//                     <Typography sx={{
//                         fontSize: matches ? 25 : 15
//                     }}><strong>Средний чек, ₽</strong></Typography>
//                     <TextField
//                         type='number'
//                         size='small'
//                         placeholder='0'
//                         onChange={averageBillOnChange}
//                         value={averageBill !== null && averageBill}/>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 2}}>
//                     <div>
//
//                         <Typography
//                             sx={{
//                                 fontSize: matches ? 25 : 15
//                             }}
//                         ><strong>Выручка</strong></Typography>
//
//                         <Typography
//                             sx={{
//                                 fontSize: matches ? 25 : 15
//                             }}
//                         >от клиентов с маркетинга, ₽</Typography>
//
//                     </div>
//                     <Box sx={{width: matches ? 200 : 120}}>
//                         <Typography sx={{
//                             display: 'flex',
//                             ml: matches ? 0 : 3,
//                             fontSize: matches ? 25 : 15
//                             // }}><strong>{earnFromClients === null ? '-' : earnFromClients.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                         }}><strong>{(averageBill * (Math.ceil((cv2 * howManyPeopleToseeUs)/100))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                     </Box>
//                 </Box>
//
//                 <Divider/>
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 2}}>
//                     <Typography
//                         sx={{
//                             fontSize: matches ? 25 : 15
//                         }}
//                     ><strong>Постоянные клиенты</strong>
//                     </Typography>
//                     <Box sx={{width: matches ? 200 : 120}}>
//                         <Typography sx={{
//                             display: 'flex',
//                             ml: matches ? 0 : 3,
//                             textAlign: 'left',
//                             fontSize: matches ? 25 : 15
//                             // }}><strong>{clearClientsCounter === null ? '-' : clearClientsCounter.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                         }}><strong>{Math.floor((cv3 * ((cv2 * howManyPeopleToseeUs)/100)))}</strong></Typography>
//                     </Box>
//                 </Box>
//
//                 <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
//                     <div>
//
//                         <Typography><strong>Выручка</strong></Typography>
//                         <Typography>от постоянных клиентов, ₽</Typography>
//                     </div>
//                     <Box sx={{width: matches ? 200 : 120}}>
//                         <Typography sx={{
//                             display: 'flex',
//                             ml: matches ? 0 : 3,
//                             textAlign: 'left',
//                             fontSize: matches ? 25 : 15
//                             // }}><strong>{earningFromClient === null ? '-' : earningFromClient.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                         }}><strong>{earningsFromClientsRef.current === null ? '-' : earningsFromClientsRef.current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</strong></Typography>
//                     </Box>
//                 </Box>
//             </Box>
//             <Button onClick={buttonOnClick}>Посчитать</Button>
//         </Box>
//     );
// };
//
// export default Table;









